import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useDispatch } from 'react-redux';
import MainLayout from '../../../commons/layout/MainLayout/index';

import HeaderHs2 from '../../../commons/components/Header/headerHs2';

import ROUTERS from '../../../commons/constans/router';
import InfiniteScroll from 'react-infinite-scroll-component';
import API, { ROUTES } from '../../../commons/api/api';
import _styles from './_styles.scss';
import moment from 'moment';
import SkeletonLoadingComponent from '../../../commons/components/SkeletonLoading';
import Loading from '../../../commons/components/Loading';
import DialogComponent from '../../../commons/components/Modal/DialogComponent';

const RenderImageDetail = ({ images }) => {
  let image_render = '';
  if (images && images.length > 0) {
    images.map((value, key) => {
      image_render += `
      <div class="box-img-question">
        <img src=${value.medium} />
      </div>
      `;
    });
  }
  return (
    <div className="question__attachment" dangerouslySetInnerHTML={{ __html: image_render }}/>
  );
};

const QnaDetailPageComponent = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [stateDetail, setStateDetail] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowPopup, setIsShowPopup] = useState(false);
  const [detailQna, setDetailQna] = useState({});
  const params = useParams();
  var id = params?.id ? params?.id : '';

  const backMenuHome = () => {
    navigate(ROUTERS.QNA);
  };

  useEffect(() => {
    console.log(props?.dataDetail, 'props?.dataDetail');
    setDetailQna(props?.dataDetail);
  }, [props]);

  const openDetail = (id) => {
    // if(id == stateDetail){
    //     setStateDetail(0)
    // }else {
    //     setStateDetail(id)
    // }
  };

  const loadingDiv = (
    <div className="wrapper">
      <section className="lists">
        <div className="lists__item last">
          <div className="lists__item__content w-100 loading-content">
            <span>
              <SkeletonLoadingComponent
                circle={false}
                width="30%"
                height="14px"
              />
            </span>
            <h3>
              <SkeletonLoadingComponent
                circle={false}
                width="100%"
                height="15px"
              />
            </h3>
            <span>
              <SkeletonLoadingComponent
                circle={false}
                width="30%"
                height="14px"
              />
            </span>
          </div>
        </div>
      </section>
      <div className="container">
        <p className="content mt-3">
          <SkeletonLoadingComponent circle={false} width="100%" height="14px" />
          <SkeletonLoadingComponent circle={false} width="100%" height="14px" />
          <SkeletonLoadingComponent circle={false} width="100%" height="14px" />
          <SkeletonLoadingComponent circle={false} width="100%" height="14px" />
          <SkeletonLoadingComponent circle={false} width="100%" height="14px" />
        </p>
      </div>
    </div>
  );

  const rightIcon = () => {
    return <img src="/images/icon_delete_black.svg" alt="" />;
  };

  const showPopupDelQna = () => {
    setIsShowPopup(true);
  };

  const handleClosepopup = () => {
    setIsShowPopup(false);
  }

  const handleDelQna = () => {
    setIsLoading(true);
    API.post(ROUTES.API_QNA_DELETE, { id: id })
    .then((res) => {
      if (res.data?.status) {
        setIsLoading(false);
        setIsShowPopup(false);
        navigate(ROUTERS.QNA);
      }
    })
    .catch((e) => {
      setIsLoading(false);
      setIsShowPopup(false);
    });
  }

  const convertToBr = (content) => {
    return content.replace(/\r\n|\r|\n/g, '<br />')
  }

  return (
    <MainLayout pageID={'qna-detail'} displayBottomNav={false}>
      <HeaderHs2
        title={'나의 문의내역'}
        labelLeft={true}
        labelRight={rightIcon()}
        handleLabelLeft={backMenuHome}
        handleLabelRight={showPopupDelQna}
      />
      {props?.loading ? (
        loadingDiv
      ) : id != '' ? (
        <div className="wrapper">
          <section className="lists">
            <div className="lists__item last">
              <div className="lists__item__content">
                <span>{moment(detailQna.created_at).format('Y-MM-DD')}</span>
                <h3>{detailQna.question_subject}</h3>
                <p>{detailQna.type_qna?.name}</p>
              </div>
            </div>
          </section>

          <div
            className={`container content-question ${
              detailQna.answer_content ? ' has-answer' : ''
            }`}
          >
            <div className="question">
              {/*<p className="question__content">{detailQna.question_content}</p>*/}
              <p
                className="question__content"
                dangerouslySetInnerHTML={{ __html: detailQna.question_content }}
              />
              <RenderImageDetail images={detailQna.attachment_url} />
            </div>
          </div>
          {detailQna.answer_content ? (
            <div className="answer">
              <span className="answer__date">
                {moment(detailQna.answered_at).format('Y-MM-DD')}
              </span>
              {/*<p className="answer__title">{detailQna.answer_content}</p>*/}
              {/*<p className="answer__detail" dangerouslySetInnerHTML={{__html: detailQna.answer_content}} />*/}
              {
                  detailQna?.answer_attachment_url?.url && <div className="box-img">
                      <img className="img" src={detailQna?.answer_attachment_url?.url || ''} alt="" />
                  </div>
              }
              <div
                className="answer__detail"
                dangerouslySetInnerHTML={{ __html: detailQna.answer_content ? convertToBr(detailQna.answer_content) : '' }}
              />
              <div className="answer__phone">
                <span>
                  <img src="/images/icon_callcenter.svg" />
                </span>
                <span className="answer__phone__name">고객센터 </span>
                <span className="answer__phone__number">02-2135-5265</span>
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      ) : (
        ''
      )}

      <DialogComponent
        id={`js-show-popup-del`}
        children={``}
        show={isShowPopup}
        title={`알림`}
        closeBtn={`취소`}
        customBtn={`확인`}
        handleClose={handleClosepopup}
        handleCustom={handleDelQna}
        className={`popup-explan-message`}
      >
        <div className="content-dialog-time">
          <div className="text">
            작성한 문의글을 삭제하시겠습니까?
          </div>
        </div>
      </DialogComponent>
      {isLoading && <Loading />}
    </MainLayout>
  );
};

export default QnaDetailPageComponent;
